import React, { useState } from "react";
import { useHistory } from "react-router";
import "./SearchField.scss";

export default function SearchField({ inputRef, setShowSearchField }) {
  const [searchText, setSearchText] = useState("");
  const history = useHistory();

  const handleTextChange = (event) => {
    setSearchText(event.target.value);
  };

  const handleSearch = (event) => {
    event.preventDefault();
    setShowSearchField(false);
    history.push(`/search?s=${searchText}`);
  };

  return (
    <div className="searchbox">
      <form onSubmit={handleSearch}>
        <input
          ref={inputRef}
          placeholder="Search..."
          value={searchText}
          onChange={handleTextChange}
        />
        <button type="submit">Search</button>
      </form>
    </div>
  );
}
